import { useEffect, useState } from "react";
import { FileText } from "lucide-react";
import { api } from "@/lib/api";

export const useAssetUrl = (url) => {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    if (!url) return undefined;
    let obj; let alive = true;
    setSrc(null);
    api.get(url, { responseType: "blob" }).then(({ data }) => { if (!alive) return; obj = URL.createObjectURL(data); setSrc(obj); }).catch(() => {});
    return () => { alive = false; if (obj) URL.revokeObjectURL(obj); };
  }, [url]);
  return src;
};

export const downloadAsset = async (url, filename) => {
  const { data } = await api.get(url, { responseType: "blob" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(data); a.download = filename; a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 3000);
};

export const AssetImage = ({ url, isPdf, alt, className = "", testid }) => {
  const src = useAssetUrl(isPdf ? null : url);
  if (isPdf) return <div className={`${className} grid place-items-center bg-[#FFF6EC] text-[#FF7A00]`} data-testid={testid}><FileText size={40} /></div>;
  return src ? <img src={src} alt={alt || ""} className={className} data-testid={testid} /> : <div className={`${className} animate-pulse bg-[#FFF6EC]`} data-testid={`${testid}-loading`} />;
};
